/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var CommentCount = (function (_Component) {
	_inherits(CommentCount, _Component);

	function CommentCount() {
		_classCallCheck(this, CommentCount);

		_Component.apply(this, arguments);
	}

	CommentCount.prototype.render = function render() {
		var _classNames;

		var styles = require('./CommentCount.css');
		var _props = this.props;
		var articleID = _props.articleID;
		var link = _props.link;
		var className = _props.className;
		var color = _props.color;

		var iconClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Icon] = true, _classNames[styles['Icon--' + color]] = true, _classNames[className] = !link && className, _classNames['disqus-comment-count'] = true, _classNames));

		var Icon = _react2['default'].createElement(
			'i',
			{ className: iconClasses, 'data-disqus-identifier': articleID > 122550 ? 'baltimore-brew-' + articleID : articleID + ' https://www.baltimorebrew.com/?p=' + articleID },
			'0'
		);

		if (link) {
			var _classNames2;

			var baseClasses = _classnames2['default']((_classNames2 = {}, _classNames2[styles.Base] = true, _classNames2[className] = className, _classNames2));

			return _react2['default'].createElement(
				'a',
				{ href: link, className: baseClasses },
				Icon
			);
		}

		return Icon;
	};

	_createClass(CommentCount, null, [{
		key: 'propTypes',
		value: {
			articleID: _react.PropTypes.number,
			className: _react.PropTypes.string,
			color: _react.PropTypes.string,
			count: _react.PropTypes.number.isRequired,
			link: _react.PropTypes.string
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			articleID: null,
			color: 'grey'
		},
		enumerable: true
	}]);

	return CommentCount;
})(_react.Component);

exports['default'] = CommentCount;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CommentCount/CommentCount.js
 ** module id = 676
 ** module chunks = 0
 **/